import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Wrapper as EmotionWrapper } from './styled-emotion';
import { Wrapper as CompiledWrapper } from './styled-compiled';
import { fg } from '@atlaskit/platform-feature-flags';
export var Wrapper = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return fg('platform_media_compiled') ? /*#__PURE__*/React.createElement(CompiledWrapper, _extends({}, props, {
    ref: ref
  })) : /*#__PURE__*/React.createElement(EmotionWrapper, _extends({}, props, {
    ref: ref
  }));
});